import { useEffect } from 'react';

import useStateHandler from '@/hooks/useStateHandler';

import OnBoardingThemeSelector from './OnBoardingThemeSelector';

import './styles/OnBoardingSlider.css';

export default function OnBoardingSlider({ user_type }) {
  const { stateHandler, cacheHandler } = useStateHandler();

  useEffect(()=>{
    return () => {
      if(cacheHandler.getCacheValue("canUserCompleteOnboarding")?.data === true) {
        stateHandler.set("user_session.user_flags.onboarding_completed", true);
      }
    };
  }, []);

  return (
    <>
      <div className={`onboarding-slider gallery-spacing`}>
        <OnBoardingThemeSelector 
          user_type={user_type} 
          className={`onboarding-slider__slide`}
        />
      </div>
    </>
  );
}
